import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import type { StudentRouteParamList } from './types';

/**
 * Open the student module screen.
 *
 * `courseId` and `moduleId` are required arguments so omitting them is a type
 * error. With `strictNullChecks` off, `undefined` is assignable to `string`,
 * so React Navigation treats `ModuleScreen` params as optional and a missing
 * field on that object is allowed. A missing function argument is not.
 */
export function navigateToModuleScreen(
  navigation: NativeStackNavigationProp<StudentRouteParamList>,
  courseId: string,
  moduleId: string,
): void {
  navigation.navigate('ModuleScreen', { courseId, moduleId });
}
